import React from 'react'
import {
  GelForm,
  GelFormField,
  useGelFormData,
  GelSelect,
  GelButton,
  GelBoxLayout
} from '@tal-gel/components'

const SelectInput = ({ question, onQuestionAnswered }) => {
  const { formData, onFormDataChange, onFormDataReset, resetForm } =
    useGelFormData({
      value: null
    })

  const onSubmit = () => {
    onQuestionAnswered({ [question.apiName]: formData.value })
  }

  const onError = (error) => {
    console.error('error', error)
  }

  return (
    <GelForm
      width={'100%'}
      labelAtTop
      disableOnSubmit
      preventSubmitOnInvalid
      onSubmit={onSubmit}
      reset={resetForm}
      onReset={onFormDataReset}
      onError={onError}
    >
      <GelFormField label='' tooltip=''>
        <GelSelect
          name='value'
          value={formData.value}
          onChange={onFormDataChange}
          placeholder='Please select'
          options={question.answers.map(({ title, value }) => ({
            label: title,
            value
          }))}
          required
          errorMsg={{
            required: 'This field is required'
          }}
        />
      </GelFormField>
      <GelBoxLayout space='auto' distribution='start'>
        <GelFormField>
          <GelButton
            name='' // Makes it a managed component
            primary
            medium
            submit
          >
            Submit
          </GelButton>
        </GelFormField>
        <GelFormField>
          <GelButton
            name='' // Makes it a managed component
            secondary
            medium
            onClick={onFormDataReset}
          >
            Reset
          </GelButton>
        </GelFormField>
      </GelBoxLayout>
    </GelForm>
  )
}

export default SelectInput
